import { Building, Home, Users, Shield, Settings, Handshake } from "lucide-react";

const services = [
  {
    icon: Building,
    title: "Property Acquisition",
    description: "Your partner in finding the perfect property.",
    details: "We simplify the search for your dream home or next investment. Moving beyond online listings, we leverage our local expertise to identify off-market opportunities and properties that match your specific criteria. From initial viewing to offer negotiation, we guide you through every step to secure the best possible value in Nairobi's competitive market."
  },
  {
    icon: Home,
    title: "Developer Marketing & Sales",
    description: "Bringing visionary developments to the market.",
    details: "We act as the bridge between developers and qualified buyers. Our team creates bespoke marketing strategies to showcase new developments, handling everything from branding and staging to buyer qualification and sales. We ensure your project achieves maximum visibility and rapid turnover."
  },
  {
    icon: Users,
    title: "Rental Services (Furnished & Unfurnished)",
    description: "Flexible living solutions for every lifestyle.",
    details: "We manage the full rental cycle for both landlords and tenants. Whether you are seeking a premium furnished executive suite for a short-term stay or a long-term unfurnished family home, we maintain a vetted portfolio of quality properties. For landlords, we ensure minimal vacancy periods and reliable, pre-qualified tenants."
  },
  {
    icon: Shield,
    title: "Legal Coordination",
    description: "Seamless transactions with dedicated legal oversight.",
    details: "We believe due diligence is non-negotiable. We work exclusively with a dedicated team of property lawyers who specialize in conveyancing and title verification. This integrated legal support ensures that every contract, transfer, and search is handled with precision, protecting your interests and providing complete peace of mind."
  },
  {
    icon: Settings,
    title: "Comprehensive Property Management",
    description: "Protecting your asset, enhancing your return.",
    details: "Maximize the value of your investment without the daily hassle. We act as your personal estate manager, handling everything from tenant sourcing and rent collection to routine maintenance and emergency repairs. Our proactive approach preserves the condition of your property while ensuring steady, reliable income."
  },
  {
    icon: Handshake,
    title: "Client Representation",
    description: "Your interests, professionally represented.",
    details: "Navigate the complex real estate landscape with a trusted advisor by your side. We offer exclusive buyer and seller representation, ensuring your interests are protected during negotiations and transactions. Whether navigating regulatory requirements or negotiating complex deals, we provide the strategic advice you need to make informed decisions."
  },
];

const ServicesSection = () => {
  return (
    <section id="services" className="py-20 md:py-24 bg-brand-canvas">
      <div className="px-6 md:px-16 max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <p className="font-open-sans font-semibold text-xs tracking-[0.3em] uppercase text-accent mb-6">Our Expertise</p>
          <h2 className="font-open-sans font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-primary-foreground mb-6">Premium Services</h2>
          <p className="font-open-sans text-sm text-primary-foreground/75 max-w-2xl mx-auto">
            Comprehensive real estate solutions tailored for the Kenyan luxury property market
          </p>
          <p className="font-open-sans font-semibold italic text-lg md:text-xl lowercase text-dusty-rose max-w-3xl mx-auto">
            comprehensive real estate solutions for every need
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={service.title}
              className="bg-brand-surface border border-metallic-tan/20 rounded-2xl p-8 backdrop-blur-sm hover:shadow-lg transition-all duration-300 hover:border-metallic-tan/50 group"
            >
              <div className="flex items-center justify-between mb-6">
                <div className="p-3 bg-metallic-tan/10 rounded-lg group-hover:bg-metallic-tan/20 transition-colors">
                  <service.icon className="w-6 h-6 text-metallic-tan" />
                </div>
                <span className="font-open-sans font-light text-xs text-dusty-rose tracking-widest opacity-70">
                  0{index + 1}
                </span>
              </div>
              
              <h3 className="font-open-sans font-bold text-xl text-metallic-tan mb-4 uppercase tracking-[0.1em]">
                {service.title}
              </h3>
              
              <p className="font-open-sans font-semibold text-sm leading-relaxed text-white mb-6">
                {service.description}
              </p>
              
              <div className="mt-auto">
                <p className="font-open-sans font-medium text-xs leading-relaxed text-white/80 line-clamp-3">
                  {service.details}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a
            href="/services"
            className="inline-block font-open-sans font-bold text-xs tracking-[0.25em] uppercase bg-metallic-tan text-emerald-green px-10 py-4 hover:bg-metallic-tan/90 transition-colors duration-300"
          >
            View All Services
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
